import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import withViewHide from 'components/common/hoc/withViewHide'
import { isMobile } from 'components/common/Media/helpers'
import Review from './Review'
import { getAppointments } from 'selectors/getAppointments'
import { getCurrentStoreEnableAppointmentFlag, getCurrentStore } from 'selectors/getCurrentStore'
import { getServicesDisplayNames, getSelectedVehicle, getSelectedTime, getSelectedContactInfo } from './selectors'
import { getValues as getFormValues } from 'components/Appointment/selectors'
import { generateAddress } from 'helpers/storeLocator'
import { isDateInAppointments } from './helpers'
import { setIsTrailer } from '../../../actions'
import {
  QUICK_APPOINTMENT__SUMMERY_PRODUCT_TITLE
} from '../../../constants'

const mapStateToProps = state => {
  const {
    catalogRefIds,
    activeVehicleId,
    appointmentDate,
    ...values
  } = getFormValues(state) || {}

  const myStore = getCurrentStore(state)
  const {
    servicesList,
    vehicles,
    quoteProductsAndCervices,
    isTrailer,
    dates
  } = getAppointments(state)

  const {
    date = {},
    time = {}
  } = !!appointmentDate && isDateInAppointments({ appointmentDate, dates }) ? appointmentDate : {}

  return {
    hasStore: Boolean(myStore),
    appointmentEnable: getCurrentStoreEnableAppointmentFlag(state),
    isPrevPageVisible: !isMobile(),
    selectedServices: catalogRefIds ?
      getServicesDisplayNames({ servicesList, catalogRefIds }) :
      quoteProductsAndCervices,
    selectedVehicle: getSelectedVehicle({ vehicles, activeVehicleId, isTrailer }),
    selectedStore: generateAddress(myStore || {}),
    selectedContactInfo: getSelectedContactInfo(values),
    ...getSelectedTime({ date, time: time || {}})
  }
}

const withSummaryProps = withProps(() => ({
  productPlaceholder: QUICK_APPOINTMENT__SUMMERY_PRODUCT_TITLE
}))

export default compose(
  connect(mapStateToProps, { setIsTrailer }),
  withViewHide(({ appointmentEnable, hasStore }) => hasStore && !appointmentEnable),
  withSummaryProps
)(Review)
